<div class="main-page-content">
  <div class="main-page-content-block">
    <h2>AI Model Pricing</h2>
    <p class="alert alert-info">
      Prices are USD per one million tokens. Any active model with a blank input or output price cannot be used.
    </p>

    <div class="table-responsive">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Model</th>
            <th>Model ID</th>
            <th>Input USD / 1M tokens</th>
            <th>Output USD / 1M tokens</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let model of models">
            <td>{{model.DisplayName}}</td>
            <td><code>{{model.ModelID}}</code></td>
            <td>
              <input type="number" min="0" step="0.0000000001" class="form-control"
                     [(ngModel)]="model.InputUsdPerMillionTokens" />
            </td>
            <td>
              <input type="number" min="0" step="0.0000000001" class="form-control"
                     [(ngModel)]="model.OutputUsdPerMillionTokens" />
            </td>
            <td>
              <input type="checkbox" [(ngModel)]="model.Active" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <button class="btn btn-success" [class.button-loading]="loading" (click)="save()">Save</button>
  </div>
</div>
